<!--Title Section-->
<app-title-jumbo title="My Portfolio" comment="Manage portfolios and get the best of this application"></app-title-jumbo>

<!--Synthesis Section-->
<section>
  <div class="container">
    <div class="offset-1 col-10">
      <!-- Card deck -->
      <div class="card-deck">

        <!-- Card Current Portfolio -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/001.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='current'? 'rgb(118,168,255)' : 'grey'}"><i class="fab fa-elementor fa-lg"></i>&nbsp;&nbsp;&nbsp; Current Portfolio</h4>
            <!--Text-->
            <p class="card-text">Select the cluster of portfolios and get access to analytics or resume an going process. Some charts will help...</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='current'">Current Portfolio</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small class="text-muted">Poftfolios: 12</small>
          </div>

        </div>
        <!-- Card Current Portfolio -->

        <!-- Card Create Portfolio -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/002.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='create'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-feather-alt fa-lg"></i>&nbsp;&nbsp;&nbsp; Create Portfolio</h4>
            <!--Text-->
            <p class="card-text">How can I create a portfolio? Upload an existing portfolio or select funds in the database and define the weighting scheme.</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='create'">Create Portfolio</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small class="text-muted">Last creation {{ '2020-03-17' | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Create Portfolio -->

        <!-- Card Update Portfolio -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/003.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='update'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-sync-alt fa-lg"></i>&nbsp;&nbsp;&nbsp; Update Portfolio</h4>
            <!--Text-->
            <p class="card-text">To get access to the monitoring function embedded in the Monitoring module, series of historical returns must be updated.</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='update'">Update Portfolio</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small class="text-muted">Last update: {{ '2020-03-27' | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Update Portfolio -->

      </div>
      <!-- Card deck -->
    </div>

  </div>
</section>
<!--Synthesis Section-->

<!--Current Portfolio Section-->
<app-my-portfolio-current *ngIf="selectBlock=='current'"></app-my-portfolio-current>
<!--Current Portfolio Section-->

<!--Create Portfolio Section-->
<app-my-portfolio-create *ngIf="selectBlock=='create'"></app-my-portfolio-create>
<!--Create Portfolio Section-->

<!--Update Portfolio Section-->
<app-my-portfolio-update *ngIf="selectBlock=='update'"></app-my-portfolio-update>
<!--Update Portfolio Section-->
